// Vehicle State
export enum VEHICLE_STATE {
  NEW = 'new',
  USED = 'used',
  DEMO = 'demo',
}
export const vehicleStateOptions = Object.values(VEHICLE_STATE)
export type VehicleState = (typeof vehicleStateOptions)[number]
export const vehicleStateMap = {
  [VEHICLE_STATE.NEW]: 'New',
  [VEHICLE_STATE.USED]: 'Used',
  [VEHICLE_STATE.DEMO]: 'Demo',
}
